import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_PROMOTION} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {RankUpContent} from './RankUpContent';
import reportPayload from './reportPayload';

export const RankUpReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Rank Up')}
      description={tt(
        'description',
        'Coaches within your organization that have achieved a new Highest Rank Achieved (HRA) in last close period.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={RankUpContent}
    />
  );
};

export default withHOC(
  withTranslation('report.rankUp'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_PROMOTION,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.rankUp', 'Rank Up'),
    },
  }),
)(RankUpReport);
